<template>
  <div aria-live="polite" aria-atomic="true" style="">
    <div style="position: fixed; bottom: 5px; right: 5px;">
      <transition-group name="fade">
        <div :class="'alert-dismissible alert fade show alert-'+message.status" role="alert" v-for="message in messages.slice().reverse()" :key="message.id">
          <span v-html="message.text"></span>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
/*global $*/
export default {
  data () {
    return {
      messages: []
    }
  },
  computed: {
    storeMessages: function() {
      return this.$store.state.Messages
    }
  },
  mounted () {
    $('.alert').alert()
  },
  watch: {
    storeMessages: function (value) {
      if(value.length == 0) return
      value.forEach(el => {
        let id = Math.random()
        this.messages.push({id:id,...el})
        setTimeout(() => {
          this.messages.shift()
        }, 5000);
      });
      this.$store.commit('clearMessages')
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
